import {useEffect, useState} from 'react';

const useViewportSize = () => {
  const [ width, setWidth ] = useState(window.innerWidth);

  useEffect(() => {
    let debounceTimer = null;

    const resizeListener = () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      debounceTimer = setTimeout(() => {
        const w = window.innerWidth;
        setWidth(w);
      }, 200);
    };

    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    }

  }, []);

  return width;
};

export default useViewportSize;
